import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="intro-band" (app/views/saved_maps/_intro.html.erb): the band that closes with × to one line that
// brings it back, and the browser remembers which. An inline script after the band applies a remembered close before first
// paint; connect() repeats it, and a morph, which keeps the controller but restores the open markup, gets it again.
export default class extends Controller<HTMLElement> {
	static targets = ["opened", "closed"];
	static values = { key: String };
	declare readonly openedTarget: HTMLElement;
	declare readonly closedTarget: HTMLElement;
	declare readonly keyValue: string;

	private readonly restore = () => {
		try {
			if (localStorage.getItem(this.keyValue) === "closed") this.show(false);
		} catch {
			// Storage blocked: keep the band open.
		}
	};

	connect() {
		this.restore();
		this.element.addEventListener("turbo:morph-element", this.restore);
	}

	disconnect() {
		this.element.removeEventListener("turbo:morph-element", this.restore);
	}

	close() {
		try {
			localStorage.setItem(this.keyValue, "closed");
		} catch {
			// Storage blocked: the band closes for this visit only.
		}
		this.show(false);
		this.closedTarget.querySelector<HTMLElement>("button")?.focus();
	}

	open() {
		try {
			localStorage.removeItem(this.keyValue);
		} catch {
			// Storage blocked: the band opens for this visit only.
		}
		this.show(true);
		this.openedTarget.querySelector<HTMLElement>("button")?.focus();
	}

	private show(opened: boolean) {
		this.openedTarget.hidden = !opened;
		this.closedTarget.hidden = opened;
		if (!opened) for (const video of this.openedTarget.querySelectorAll("video")) video.pause();
	}
}
